export default "__VITE_ASSET__6675ce30__"